<template><div class="settings main flex">
  <sticky-bar :loading="loading">Password Reset</sticky-bar>
  <div class="flex-fill padded scroll">
    <div v-if="success">
      <h1>Success!</h1>
      <p>You have successfully reset your password.
        <router-link to="/login">Click here to log in.</router-link></p>
    </div>
    <div v-else-if="loading">
      Retrieving password reset code ... <Loading />
    </div>
    <div v-else-if="closeMe === true">
      Request sent. Please close this window and check your inbox for a password reset email. The password reset link will expire in 10 minutes.
    </div>
    <div v-else-if="closeMe">
      Request sent. If your email address matches one we have file, then you should receive a password reset email shortly. The password reset link will expire in 10 minutes.
    </div>
    <div v-else-if="!code">
      <template v-if="user && user.email">
      You email address is <b>{{ user.email }}</b>.
      </template>
      <template v-else>
      <table>
      <tr><th>Email:</th>
        <td><input placeholder="your email" v-model="email" @keypress.enter="requestPasswordReset"/></td></tr>
      </table>
      </template>
      <p><button
          @click.prevent="requestPasswordReset"
          :disabled="signing || (!email && !(user && user.email))">
        Click here to receive a password reset email.</button></p>
      <p v-if="error" class="error">An error occurred.</p>
    </div>
    <div v-else-if="confirmation === null">
      

      <span class="warning" v-if="error.type === 'LoggedIn'">
        You are already logged in.
        <a href="#" @click.prevent="$store.dispatch('logout')">
          Click here to log out and retry.
        </a>
      </span>
      <span class="warning" v-else-if="error.type === 'DoesNotExist'">
        Your invitation could not be found; perhaps it has expired.
      </span>
      <span class="warning" v-else>
        An error occurred while retrieving your invitation.
        <button @click="getConfirmation">Try Again</button>
      </span>
    </div>
    <div v-else>
      <p>Please complete the following form to reset your password:</p>
      <form action="." method="POST" autocomplete="off" @submit.prevent="submit">
      <table>
      <tr>
        <th>Email:</th>
        <td class="email">
          <input
              name="username" 
              :value="confirmation.sentTo" 
              type="text" 
              autocomplete="off"
              tabindex="-1"
              class="username" />
          <span class="username" v-html="confirmation.sentTo" />
        </td></tr>
      <tr>
        <th>Password:</th>
        <td>
          <div>
            <input v-model="password1" type="password" autocomplete="off" />
            <span v-if="pcheck.feedback.warning" class="warning"> {{pcheck.feedback.warning}}</span>
          </div>
        </td>
      </tr>
      <tr v-if="password1">
        <th />
        <td>
          <div class="meter">
            <div :class="`score-${score}`" />
            {{ scoreName }}
          </div>
          <p v-if="pcheck.feedback.suggestions.length">
            Suggestions:
            <ul>
              <li v-for="(s,i) in pcheck.feedback.suggestions" :key="`s-${i}`" v-html="s" />
            </ul>
          </p>
        </td>
      </tr>
      <tr>
        <th>Password (again):</th>
        <td><input v-model="password2" type="password" autocomplete="off" /></td>
      </tr>
      <tr>
        <th />
        <td>
          <span class="warning" v-if="!password1 || !password2">
            All fields are required.
          </span>
          <span class="warning" v-else-if="password1 != password2">
            Passwords do not match.
          </span>
          <Loading v-else-if="loading" />
          <button v-else>Submit</button>
          <div v-if="error" class="warning" v-html="error" />
        </td>
      </tr>
      </table>
      </form>
    </div>
  </div>
</div></template>
<script>
import api from '../api'
import Loading from './Loading'
import StickyBar from './StickyBar'
import pcheck from 'zxcvbn'
const scores = [ 'Very Weak', 'Weak', 'Fair', 'Good', 'Excellent' ]
export default {
  name: 'onboarding',
  components: { Loading, StickyBar },
  props: [ 'code' ],
  data() {
    return {
      loading: false,
      confirmation: null,
      closeMe: false,
      email: '',
      password1: '',
      password2: '',
      signing: false,
      error: null,
      success: false,
    }
  },
  created() {
    this.getConfirmation()
  },
  computed: {
    pcheck() { return pcheck(this.password1) },
    score() { return this.pcheck.score },
    scoreName() { return scores[this.score] },
    user() { return this.$store.state.user },
  },
  methods: {
    async requestPasswordReset() {
      let email = this.email || (this.user && this.user.email)
      if (!email) return
      if (this.ref) this.ref.cancel()
      this.signing = true
      this.error = null
      let ref = this.ref = { email }
      try {
        await api.requestPasswordReset(ref)
        if (this.user && this.user.email)
          this.closeMe = true
        else
          this.closeMe = 1
      } catch(e) {
        this.error = e
        console.error(e)
      } finally {
        if (ref === this.ref) {
          this.ref = null
          this.signing = false
        }
      }
    },
    async getConfirmation() {
      if (!this.code) return
      if (this.ref) this.ref.cancel()
      this.loading = true
      this.error = null
      let ref = this.ref = { code: this.code, purpose: 2 }
      try {
        this.confirmation = await api.getConfirmation(ref)
      } catch(e) {
        this.error = e
        console.error(e)
      } finally {
        if (ref === this.ref) {
          this.ref = null
          this.loading = false
        }
      }
    },
    async submit() {
      if (!this.password1) return
      if (this.password1 !== this.password2) return
      if (this.ref) this.ref.cancel()
      this.signing = true
      this.error = null
      let ref = this.ref = {
        code: this.code,
        password: this.password1,
      }
      try {
        await api.resetPassword(ref)
        this.success = true
      } catch(e) {
        if (ref === this.ref) {
          if (e.type === 'WeakPassword')
            this.error = 'Try a stronger password.'
          else if (e.type === 'DoesNotExist')
            this.error = 'An error occurred. Probably your password reset link expired.'
          else
            this.error = 'An error occurred. Please try again.'
        }
        console.error(e)
      } finally {
        if (ref === this.ref) {
          this.ref = null
          this.signing = false
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
h1 { margin-top: 0; }
$w: 180px;
th {
  text-align: right;
  width: 0;
  white-space: nowrap;
}
td.email {
  position: relative;
}
input.username {
  pointer-events: none;
  border: 0;
  outline: 0;
  background: inherit;
  background-image: none !important;
  font-style: italic;
  padding: 0;
  position: absolute;
  width: 99%;
}
span.username {
  position: relative;
  font-style: italic;
  background: #eee;
  z-index: 100;
  width: 100%;
  display: block;
}
.Password {
  margin: 0;
  width: $w;
  .Password__strength-meter {
    margin: 10px 0;
  }
}
input {
  width: $w;
  box-sizing: border-box;
}
.meter {
  display: relative;

  > div { height: 3px; margin-bottom: 2px; }
  .score-0 { width: $w; background: #ccc; }
  .score-1 { width: calc($w/4); background: #c00; }
  .score-2 { width: calc($w/2); background: #cc0; }
  .score-3 { width: calc($w*3/4); background: #00c; }
  .score-4 { width: $w; background: #0c0; }
}
.warning {
  color: #c00;
}
</style>
